import { toastConstant } from 'constants/toastmessage';
import { useToast } from 'context/ToastContext';
import { useEffect, useState } from 'react';
import { listclientIntake, shareClientIntakeService } from 'services/intakeforms/clientIntakeService';
import { convertObjectToQuery, fallbackCopyTextToClipboard } from 'utils/utils';
import { getClientUserList } from 'services/case/caseServices';
import { generateFullName } from 'utils/generateFullNameUtils';

export default function useShareIntakeForms(case_id, practiceArea = []) {
  const { addToast } = useToast();
  const [clientData, setClientData] = useState([]);

  const getContactList = (caseId) => {
    getClientUserList({
      caseId,
      is_mandatory_lawft_access: false,
      is_team_member_list: false,
      all_contacts: true,
      is_active: true,
      is_include_groups: false,
      active_groups: true,
    })
      .then((response) => {
        const mappedContacts = response.data?.map((v) => ({ fullName: generateFullName(v), ...v }));
        // Sort contacts alphabetically using the logic: first_name || title
        const sortedContacts = mappedContacts?.sort((a, b) => {
          const nameA = a?.first_name || a?.title || '';
          const nameB = b?.first_name || b?.title || '';
          return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
        });
        setClientData(sortedContacts);
      })
      .catch((error) => console.log(error));
  };

  const shareIntakeFrom = async (params) => {
    try {
      const res = await shareClientIntakeService(convertObjectToQuery(params));
      const lawftLink = res?.data?.lawft_link;

      if (!res?.data?.recipient || res?.data?.recipient === 'no recipient/invalid email') {
        try {
          setTimeout(() => {
            navigator.clipboard.writeText(lawftLink);
          }, 0);
          addToast(false, toastConstant.toasterType.WARNING, toastConstant.api.SUCCESS, toastConstant.message.CLIPBOARD_COPY_SUCCCESS);
        } catch (err) {
          console.log(err);
          fallbackCopyTextToClipboard(lawftLink);
          addToast(false, toastConstant.toasterType.WARNING, toastConstant.api.SUCCESS, toastConstant.message.CLIPBOARD_COPY_SUCCCESS);
        }
      } else {
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.SHARE_INTAKE_SUCCESS);
      }
    } catch (err) {
      console.log(err);
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.SHARE_INTAKE_FAILED);
    }
  };

  const IntakeSearch = async (keyword = '', within_case = true) => {
    const qs = {
      limit: 20,
      form_type: 'contact_form',
      keyword,
    };
    const list = await listclientIntake(convertObjectToQuery(qs), { practice_area: (practiceArea = []), within_case });
    return list?.data?.contact_forms || [];
  };

  useEffect(() => {
    if (case_id) {
      getContactList(case_id);
    }
  }, []);

  return { clientData, IntakeSearch, shareIntakeFrom, getContactList };
}
